import { render, staticRenderFns } from "./new-notif.vue?vue&type=template&id=4bb29cce"
import script from "./new-notif.vue?vue&type=script&lang=js"
export * from "./new-notif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bb29cce')) {
      api.createRecord('4bb29cce', component.options)
    } else {
      api.reload('4bb29cce', component.options)
    }
    module.hot.accept("./new-notif.vue?vue&type=template&id=4bb29cce", function () {
      api.rerender('4bb29cce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notification-manager/new-notif.vue"
export default component.exports